<template>
    <el-dialog
        class="coupon-dialog"
        :visible.sync="couponDialogVisible"
        :close-on-click-modal="false"
        @closed="closeDialog"
        width="350px"
        :lock-scroll="false"
        :modal-append-to-body="false"
        append-to-body
    >
        <div class="coupon-dialog-content">
            <el-image
                :src="require('@/assets/image/coupon/coupon.png')"
                fit="fill"
            ></el-image>
            <el-image
                :src="require('@/assets/image/coupon/button.png')"
                fit="fill"
                class="shopnow-btn"
                @click="shopnow"
            ></el-image>
        </div>
    </el-dialog>
</template>

<script>
import { cmofferApi } from "@/http/cmofferApi.js";
export default {
    methods: {
        closeDialog() {
            this.$emit("update:couponDialogVisible", false);
        },
        shopnow() {
            this.$router.push({
                path: "/goodsList",
            });
            this.closeDialog();
            cmofferApi.couponNotify({}, "post")
        },
    },
    props: {
        couponDialogVisible: Boolean,
    },
    watch: {
        couponDialogVisible(val) {
            if (val) {
            }
        },
    },
};
</script>

<style lang="scss">
.coupon-dialog {
    .el-dialog__header {
        background: $color-white;
        border-top-color: $color-white;
    }
    .el-dialog__body {
        padding: 0 !important;
        .coupon-dialog-content {
            display: flex;
            flex-direction: column;
            justify-content: center;
            .shopnow-btn {
                cursor: pointer;
            }
        }
    }
}
</style>

